<h2 mat-dialog-title>Hak Cuti {{ data.fullname }}</h2>
<mat-dialog-content class="mat-typography">
    <form class="form-container" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Hak Cuti {{ curYear }}</mat-label>
                <input matInput type="number" [formControl]="hakCutiN" required />
                <mat-error *ngIf="hakCutiN.invalid">{{
                    getErrorMessage(hakCutiN)
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Hak Cuti {{ yearN1 }}</mat-label>
                <input matInput type="number" [formControl]="hakCutiN1" required />
                <mat-error *ngIf="hakCutiN1.invalid">{{
                    getErrorMessage(hakCutiN1)
                    }}</mat-error>
            </mat-form-field>
        </p>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close *ngIf="!isLoading">Batal</button>
    <button mat-raised-button cdkFocusInitial color="primary" *ngIf="!isLoading" (click)="f.form.valid && onSubmit()">
        Simpan
    </button>
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</mat-dialog-actions>